<template>
  <no-auth v-if="!hasAuthorize.list"></no-auth>
  <div :class="{ 'o-card': !tab }" v-else>
    <Table
      no-card
      :title="$t(`${name}.mainTitle`)"
      :description="$t(`${name}.description`)"
      i18n
      no-search
      :loading="loading"
      :status="$status.series"
      :items="items"
      checkable
      :checkValue="checkedList"
      @change:sort="SET_CHANGE_SORT"
      @change:checkedList="checkedList = $event"
      @change:selectAllWithoutPage="SET_CHECKED_ALL"
      :headers="headers"
      :page="page"
      :count="count"
      :pages="pages"
      :searchValue="search"
      @change:search="setSearch"
      @change:page="setChangedPage"
      :searchPlaceholder="$t(`${name}.searchPlaceholder`)"
    >
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <ExcelExport
            :fileName="`${name}-export-${date()}`"
            :fields="exportFields"
            :data="checkedList.length > 0 ? checkedList : items"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>
          <router-link :to="{ name: `tks-calculating` }">
            <Button v-if="hasAuthorize.add" variant="light-primary">
              + {{ $t(`${name}.add`) }}
            </Button>
          </router-link>
        </div>
      </template>
      <template #selectedCerealType="{ item }">
        <router-link
          :to="{ name: `tks-calculating-detail`, params: { id: item.id } }"
        >
          {{ item.selectedCerealType }}
        </router-link>
      </template>
      <template #insulationDimensions="{ item }">
        <div>
          <span>{{ $t("tks.airInitialTemperature") }} :</span>
          {{ item.airInitialTemperature }} °C
        </div>
        <div>
          <span>{{ $t("tks.airInitialHumidity") }} :</span>
          {{ item.airInitialHumidity }} %
        </div>
      </template>
      <template #airFinalTemperature="{ item }">
        <div>
          <span>{{ $t("tks.airFinalTemperature") }} :</span>
          {{ item.airFinalTemperature }} °C
        </div>
        <div>
          <span>{{ $t("tks.airFinalHumidity") }} :</span>
          {{ item.airFinalHumidity }} %
        </div>
      </template>
      <template #info="{ item }">
        <div
          class="u-margin-bottom-xsmall u-display-flex u-align-items-center u-justify-content-flex-end"
        >
          <div class="u-color-primary u-margin-right-xsmall">
            <i class="icofont-calendar"></i> {{ date(item.createdDate) }}
          </div>
          <chip
            class="u-margin-0"
            :variant="item.isActive ? 'success' : 'danger'"
          >
            {{ item.isActive ? $tc("common.active") : $tc("common.passive") }}
          </chip>
          <Button
            @click="REMOVE_TO(item)"
            variant="light-danger"
            class="u-margin-0 u-float-right"
          >
            <i class="icofont-trash"></i>
          </Button>
        </div>
      </template>
      <template #updatedDate="{ item }">
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.updatedDate) }}
        </div>
      </template>
    </Table>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Button from "../../Base/Button.vue";
import ExcelExport from "../../Base/ExcelExport.vue";
import Requests from "@/services/Requests";
import mainProjectExportFields from "./export";
import Chip from "../../Base/Chip.vue";
import authorize from "./authorize";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
export default {
  components: {
    Table,
    Button,
    ExcelExport,
    Chip,
    RemoveModal,
  },
  mixins: [mainProjectExportFields, authorize],
  props: {
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "tks",
      checkedList: [],
      showLockedModal: false,
      showRemoveModal: false,
      newMainProject: false,
      filter: {},
      sort: {},
      page: 1,
      search: "",
      items: [],
      loading: true,
      count: 0,
      headers: [
        {
          col: 6,
          sm: 2,
          md: 2,
          lg: 2,
          title: "tks.grainNames",
          value: "selectedCerealType",
        },
        {
          col: 5,
          sm: 1,
          md: 1,
          lg: 1,
          title: "tks.deviceNames",
          value: "deviceName",
        },
        {
          col: 6,
          sm: 2,
          md: 2,
          lg: 2,
          title: "tks.airInitialTemperature",
          value: "insulationDimensions",
        },
        {
          col: 6,
          sm: 3,
          md: 3,
          lg: 3,
          title: "tks.airFinalTemperature",
          value: "airFinalTemperature",
        },

        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "",
          value: "info",
        },
      ],
      removeModal: { status: false, item: {} },
      lockedModal: { status: false, item: {} },
      showDetailModal: { status: false, adminDetailStatus: false, item: null },
    };
  },
  computed: {
    ...mapGetters({
      getActiveUser: "getActiveUser",
    }),
    pages() {
      return Math.ceil(this.count / 10);
    },
    exportFields() {
      if (this.items.length === 0) return {};
      return this.getExcelFields();
    },
  },
  methods: {
    SET_CHANGE_SORT(headers) {
      const sortedHeaders = headers.filter((item) => item.sort);
      if (sortedHeaders.length === 0) {
        this.sort = {};
        this.getItemsOfPage();
      } else {
        const sort = sortedHeaders[0];
        if (sort.sort.includes("name")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "ALPHABETIC",
          };
        } else if (sort.sort.includes("info")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "DATE",
          };
        }
        this.getItemsOfPage();
      }
    },
    async SET_CHECKED_ALL(data) {
      if (data) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
        });
        const response = await Requests.Tks.GetAll({
          query: { page: 1, limit: this.count, search: this.search },
        });
        this.$status.series = response.message;
        if (response.message === "OK") {
          console.log(response.data);

          this.checkedList = [...response.data.items];
        }
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      }
    },
    showDetail(item) {
      this.$router.push({
        name: "tks-calculating-detail",
        params: { id: item.id },
      });
    },
    showAdminDetail(item) {
      this.showDetailModal = {
        status: false,
        adminDetailStatus: true,
        item: item,
      };
    },
    date(value = new Date()) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    SET_LOCKED_DESCRIPTION() {
      return this.lockedModal.item.isLocked ? "unlocked" : "locked";
    },
    REMOVE_TO(item) {
      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await Requests.Tks.Delete({
        params: { id: this.removeModal.item.id },
      });
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeSuccess`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeError`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const search = this.$route.query.search;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      this.getItemsOfPage();
    },
    async getItemsOfPage() {
      this.loading = true;
      this.removeModal = { status: false, item: {} };
      this.lockedModal = { status: false, item: {} };
      const response = await Requests.Tks.GetAll({
        query: {
          limit: 10,
          page: this.page,
          search: this.search,
          ...this.filter,
          ...this.sort,
          ...this.query,
        },
      });
      this.$status.vincCalculating = response.message;
      if (response.message === "OK") {
        this.items = response.data.items;
        this.count = response.data.count;
      }
      this.loading = false;
    },
    setSearch(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search, page: 1 },
      });
      this.getItemsOfPage();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
      this.page = page;
      this.getItemsOfPage();
    },
    setFilter(filter) {
      const filterScoped = {
        type: filter.type || "",
        isLocked:
          filter.isLocked == null
            ? ""
            : filter.isLocked
            ? "true"
            : "false" || "",
        userId: filter.user?.id || "",
        batteryId: filter.batteryId?.id || "",
      };
      // remove
      this.filter = filterScoped;
      this.getItemsOfPage(filterScoped);
    },
  },
  mounted() {
    this.setQuery();
  },
};
</script>

<style></style>
